import * as React from 'react';
import { useDispatch } from 'react-redux';
import { Button, TextField } from '@mui/material';
import Dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import { Orders } from '../../store/slices';
import { FilterBar, useFilterBarStyles } from '../ui';
import { MIN_DATE_SENTINEL, dateParam } from '../../lib/orderFilters';

/**
 * Date range (plus the two fixed template names in compare mode) used by Tag stats and A/B testing.
 * The component keeps its historical export name `MockupHistoryFilters`.
 */
export default function MockupHistoryFilters(props: any) {
    const { queryParams, loadMockups, loading, isCompareMode = false } = props;
    const dispatch = useDispatch();
    const classes = useFilterBarStyles();

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        const newQueryParams = { ...queryParams, [name]: value };
        if (name === 'maxDate') {
            if (!newQueryParams.minDate) {
                newQueryParams.minDate = value;
            } else {
                const maxDateObj = dayjs(newQueryParams.maxDate);
                const minDateObj = dayjs(newQueryParams.minDate);
                if (maxDateObj.isBefore(minDateObj)) newQueryParams.minDate = newQueryParams.maxDate;
            }
        }
        if (name === 'minDate' && !newQueryParams.maxDate) {
            newQueryParams.maxDate = Dayjs(new Date()).format('YYYY-MM-DD');
        }
        loadMockups(newQueryParams);
    };

    const onDate = (name: 'minDate' | 'maxDate') => (value: Dayjs.Dayjs | null) => {
        const iso = dateParam(value);
        if (iso) handleFilterChange({ target: { name, value: iso } });
    };

    const clear = () => {
        dispatch(Orders.clearFilters());
        const clearParams: any = {
            maxDate: Dayjs(new Date()).format('YYYY-MM-DD'),
            minDate: Dayjs(new Date()).format('YYYY-MM-DD'),
        };
        if (isCompareMode) {
            clearParams.template1 = 'ab-current';
            clearParams.template2 = 'ab-test';
        }
        loadMockups(clearParams);
    };

    return (
        <FilterBar label="Date range">
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                    className={classes.date}
                    label="From"
                    format="YYYY-MM-DD"
                    value={queryParams?.minDate && queryParams?.minDate !== MIN_DATE_SENTINEL ? Dayjs(queryParams?.minDate) : null}
                    maxDate={queryParams?.maxDate ? Dayjs(queryParams?.maxDate) : Dayjs(new Date())}
                    disabled={loading}
                    onChange={onDate('minDate')}
                    slotProps={{ textField: { size: 'small' } }}
                />
                <DatePicker
                    className={classes.date}
                    label="To"
                    format="YYYY-MM-DD"
                    value={queryParams?.maxDate ? Dayjs(queryParams?.maxDate) : Dayjs(new Date())}
                    maxDate={Dayjs(new Date())}
                    disabled={loading}
                    onChange={onDate('maxDate')}
                    slotProps={{ textField: { size: 'small' } }}
                />
            </LocalizationProvider>
            {isCompareMode && (
                <>
                    <TextField className={classes.text} size="small" label="Template 1" name="template1" value={queryParams?.template1 || 'ab-current'} InputProps={{ readOnly: true }} />
                    <TextField className={classes.text} size="small" label="Template 2" name="template2" value={queryParams?.template2 || 'ab-test'} InputProps={{ readOnly: true }} />
                </>
            )}
            <Button className={classes.clear} variant="text" size="small" onClick={clear} disabled={loading}>
                Reset to today
            </Button>
        </FilterBar>
    );
}
